/**
 * Ingredients (new) — image lightbox via data attributes (no inline onclick).
 */
(function () {
  'use strict';

  function openImageModal(imageSrc, imageAlt) {
    var modal = document.getElementById('image-modal');
    var modalImage = document.getElementById('modal-image');
    if (!modal || !modalImage || !imageSrc) return;

    modalImage.src = imageSrc;
    modalImage.alt = imageAlt || '';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeImageModal() {
    var modal = document.getElementById('image-modal');
    if (!modal) return;

    modal.classList.remove('active');
    document.body.style.overflow = 'auto';
  }

  function openFromTrigger(trigger) {
    if (!trigger) return;
    openImageModal(
      trigger.getAttribute('data-ingredient-modal-src'),
      trigger.getAttribute('data-ingredient-modal-alt') || ''
    );
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ingredient-modal-src]');
    if (!trigger) return;
    event.preventDefault();
    openFromTrigger(trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeImageModal();
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;

    var trigger = event.target.closest('[data-ingredient-modal-src]');
    if (!trigger) return;

    event.preventDefault();
    openFromTrigger(trigger);
  });

  // Keep globals for modal close handlers still declared in Liquid
  window.openImageModal = openImageModal;
  window.closeImageModal = closeImageModal;
})();
